import React from "react";
import ReactDOM from "react-dom/client";
import { getLanguage } from "../../language/lang-utils.ts";
import { VideoPlayerDetails } from "../../types/VideoPlayerDetails.ts";
import { Tag } from "../../types/Tag.ts";
import Video from "./Video.tsx";

// Mount helper for the server-rendered player divs (landing + video pages). Lives outside
// Video.tsx so that file only exports components (react-refresh requirement).
export const renderVideo = (div: string) => {
  const root = document.getElementById(div);
  if (root == null) return;
  const landing = root.dataset["islanding"] == "true";
  const processprelive = root.dataset["processprelive"] == "true";
  const details = VideoPlayerDetails.createInstanceFromDOM(
    root.dataset,
    getLanguage(),
  );
  const tags = Tag.createArrayFromDOM(root.dataset, getLanguage());
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <Video
        id={div}
        details={details}
        isLanding={landing}
        hOnlyItem={false}
        processPrelive={processprelive}
        tags={tags}
      />
    </React.StrictMode>,
  );
};
